export function OrganizationSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Data Hire Club",
    "url": "https://datahireclub.com.br",
    "logo": "https://datahireclub.com.br/lovable-uploads/logo-horizontal.png",
    "description": "Plataforma gratuita de vagas e comunidade para profissionais de dados no Brasil",
    "foundingDate": "2024",
    "sameAs": [
      "https://www.linkedin.com/company/datahireclub"
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
